import request from '@/utils/superagent'
import handleAPIException from '@/utils/handleAPIException'
import APIS from '../apis'

export default {
  getServiceList: async function(offset, limit, order) {
    return new Promise((resolve, reject) => {
      request(
        APIS.CLOUD.GET_SERVICE_LIST.method,
        APIS.CLOUD.GET_SERVICE_LIST.path(offset, limit, order)
      ).end((err, res) => {
        if (err && res) {
          handleAPIException(res, () => {
            reject(res.body)
          })
          reject(res.body)
        } else {
          resolve(res.body)
        }
      })
    })
  },
  getServiceOptionList: async function(cloudServiceRequest) {
    return new Promise((resolve, reject) => {
      request(
        APIS.CLOUD.GET_SERVICE_OPTION_LIST.method,
        APIS.CLOUD.GET_SERVICE_OPTION_LIST.path()
      )
        .send(cloudServiceRequest)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  startService: async function(serviceUid) {
    return new Promise((resolve, reject) => {
      request(APIS.CLOUD.START_SERVICE.method, APIS.CLOUD.START_SERVICE.path())
        .send({ serviceUid })
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  stopService: async function(serviceUid) {
    return new Promise((resolve, reject) => {
      request(APIS.CLOUD.STOP_SERVICE.method, APIS.CLOUD.STOP_SERVICE.path())
        .send({ serviceUid })
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  terminateService: async function(serviceUid) {
    return new Promise((resolve, reject) => {
      request(
        APIS.CLOUD.TERMINATE_SERVICE.method,
        APIS.CLOUD.TERMINATE_SERVICE.path()
      )
        .send({ serviceUid })
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  getLicenseList: async function(offset, limit, order) {
    return new Promise((resolve, reject) => {
      request(
        APIS.CLOUD.GET_LICENSE_LIST.method,
        APIS.CLOUD.GET_LICENSE_LIST.path(offset, limit, order)
      ).end((err, res) => {
        if (err && res) {
          handleAPIException(res, () => {
            reject(res.body)
          })
          reject(res.body)
        } else {
          resolve(res.body)
        }
      })
    })
  },
  checkServiceId: async function(urlPrefix, product) {
    return new Promise((resolve, reject) => {
      request(
        APIS.CLOUD.CHECK_SERVICE_ID.method,
        APIS.CLOUD.CHECK_SERVICE_ID.path()
      )
        .send({ urlPrefix, product })
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  getMyServiceList: async function(product) {
    return new Promise((resolve, reject) => {
      request(
        APIS.CONSOLE.GET_SERVICE_MY_LIST.method,
        APIS.CONSOLE.GET_SERVICE_MY_LIST.path(product)
      ).end((err, res) => {
        if (err && res) {
          if (res.body) {
            const errorCode = res.body.errorCode ? res.body.errorCode : null
            if (errorCode === 'NOT_FOUND_DATA') {
              reject(res.body)
            }
          } else {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          }
        } else {
          resolve(res.body)
        }
      })
    })
  },
  getDescribeService: async function(serviceUid) {
    return new Promise((resolve, reject) => {
      request(
        APIS.CLOUD.DESCRIBE_SERVICE.method,
        APIS.CLOUD.DESCRIBE_SERVICE.path(serviceUid)
      ).end((err, res) => {
        if (err && res) {
          handleAPIException(res, () => {
            reject(res.body)
          })
          reject(res.body)
        } else {
          resolve(res.body)
        }
      })
    })
  },
  deleteService: async function(serviceUid) {
    return new Promise((resolve, reject) => {
      request(
        APIS.CLOUD.DELETE_SERVICE.method,
        APIS.CLOUD.DELETE_SERVICE.path()
      )
        .send({ serviceUid })
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  getBillHistoryList: async function(serviceUid) {
    return new Promise((resolve, reject) => {
      request(
        APIS.CLOUD.GET_SERVICE_BILL_HISTORY.method,
        APIS.CLOUD.GET_SERVICE_BILL_HISTORY.path(serviceUid)
      ).end((err, res) => {
        if (err && res) {
          handleAPIException(res, () => {
            reject(res.body)
          })
          reject(res.body)
        } else {
          resolve(res.body)
        }
      })
    })
  },
  getStats: async function(startDate, endDate, product) {
    return new Promise((resolve, reject) => {
      request(
        APIS.CLOUD.GET_STATS.method,
        APIS.CLOUD.GET_STATS.path(startDate, endDate, product)
      ).end((err, res) => {
        if (err && res) {
          handleAPIException(res, () => {
            reject(res.body)
          })
          reject(res.body)
        } else {
          resolve(res.body)
        }
      })
    })
  },
  setTotalPrice: async function(serviceBillHisUid, currency, totalPrice) {
    return new Promise((resolve, reject) => {
      request(
        APIS.CLOUD.SET_TOTAL_PRICE.method,
        APIS.CLOUD.SET_TOTAL_PRICE.path()
      )
        .send({ serviceBillHisUid, currency, totalPrice })
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  clickPayCash: async function(param) {
    return new Promise((resolve, reject) => {
      request(APIS.PAY.REQUEST_CASH.method, APIS.PAY.REQUEST_CASH.path())
        .send(param)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  // checkCashStatus: async function(param) {
  //   return new Promise((resolve, reject) => {
  //     request(APIS.PAY.REQUEST_CASH.method, APIS.PAY.REQUEST_CASH.path())
  //       .send(param)
  //       .end((err, res) => {
  //         if (err && res) {
  //           handleAPIException(res, () => {
  //             reject(res.body);
  //           });
  //           reject(res.body);
  //         } else {
  //           resolve(res.body);
  //         }
  //       });
  //   });
  // },
  checkUserCashStatus: async function(param) {
    return new Promise((resolve, reject) => {
      request(APIS.PAY.GET_CASH_USER.method, APIS.PAY.GET_CASH_USER.path())
        .send(param)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            // console.log(res.body)
            resolve(res.body)
          }
        })
    })
  },
  updateCashStatus: async function(param) {
    return new Promise((resolve, reject) => {
      request(APIS.PAY.UPDATE_CASH.method, APIS.PAY.UPDATE_CASH.path())
        .send(param)
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  },
  getUserNxacList: async function(product) {
    return new Promise((resolve, reject) => {
      request(
        APIS.CLOUD.GET_USER_NXAC.method,
        APIS.CLOUD.GET_USER_NXAC.path(product)
      )
        .send()
        .end((err, res) => {
          if (err && res) {
            handleAPIException(res, () => {
              reject(res.body)
            })
            reject(res.body)
          } else {
            resolve(res.body)
          }
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/Service.js